<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-3 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden border-0">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap p-2">
          <div class="col">
            <p class="text-white fw-bold mb-1 text-x">Configure Verification Services</p>
            <p class="text-xs text-white mb-0">
              Select a service and map required fields to onboarding questionnaire.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="row g-3 g-xl-4 pt-1">
      <div class="col-12">
        <article class="card border border-purple border-opacity-50 shadow-lg rounded-4 h-100">
          <div class="card-body p-3 p-lg-4 d-flex flex-column">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
              <div class="d-flex align-items-start gap-3">
                <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="bi bi-sliders fs-5"></i>
                </div>
                <div>
                  <div class="fw-bold text-x mb-1">
                    {{ selected_service?.name || selected_service?.title || 'Service Configuration' }}
                  </div>
                  <div class="text-secondary text-xs">
                    {{ selected_service?.description || 'Configure required-field mappings for this service.' }}
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button
                  type="button"
                  class="btn btn-light btn-sm text-xs d-inline-flex align-items-center gap-2 rounded-3 px-3 py-2 shadow-sm"
                  @click="go_back"
                >
                  <i class="bi bi-arrow-left"></i>
                  Back
                </button>
                <button
                  type="button"
                 class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                  :disabled="saving_configuration || !selected_service_id"
                  @click="save_configuration && save_configuration()"
                >
                  <span class="spinner-border spinner-border-sm" v-if="saving_configuration" role="status" aria-hidden="true"></span>
                  <i class="bi bi-check2-circle" v-else></i>
                  <span class="fw-semibold">{{ saving_configuration ? 'Saving...' : 'Save' }}</span>
                </button>
              </div>
            </div>

            <div v-if="!selected_service_id" class="text-center text-secondary py-5 my-auto">
              <i class="bi bi-exclamation-circle fs-2 d-block mb-2"></i>
              <p class="text-xs mb-0">No service selected. Return to the services list and click View.</p>
            </div>

            <div v-else class="d-flex flex-column gap-3">
              <div class="rounded-4 border bg-white p-3">
                <div class="fw-bold text-xs mb-2">
                  Map Required Fields
                </div>

                <div
                  v-if="(required_fields || []).length && !loading_mapping_options && !(questions || []).length"
                  class="bg-body-secondary rounded-3 border text-secondary text-xs py-2 px-3 mb-3"
                >
                  <i class="bi bi-exclamation-triangle me-2"></i>
                  No questions found for this verification form.
                  {{ mapping_options_message || 'Map onboarding questions to verification questions first.' }}
                </div>

                <div v-else-if="mapping_options_message" class="alert alert-light border text-secondary text-xs py-2 px-3 mb-3">
                  <i class="bi bi-info-circle me-2"></i>
                  {{ mapping_options_message }}
                </div>

                <div class="row g-4 align-items-center mb-2"
                  v-for="field in (required_fields || [])"
                  :key="field.key || field.name || field"
                >
                  <div class="col-12 col-md-4">
                  <div class="d-flex align-items-center gap-2">
                      <span class="badge bg-light text-secondary border rounded-pill text-xs fw-semibold px-3 py-2 w-100 text-truncate">
                        {{ format_required_field_label ? format_required_field_label(field) : (field.label || field.name || field) }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <select
                      class="form-select subsystem-select rounded-small p-1 shadow-sm text-xs"
                      :value="(field_mappings || {})[field.key || field.name || field] || ''"
                      @change="on_field_mapping_change && on_field_mapping_change(field, $event)"
                    >
                      <option value="">
                        {{ loading_mapping_options ? 'Loading questions...' : 'Select a question' }}
                      </option>

                      <optgroup
                        v-for="group in (grouped_questions || [])"
                        :key="group.section"
                        :label="group.section"
                      >
                        <option
                          v-for="question in (group.items || [])"
                          :key="question.id || question.key || question"
                          :value="question.id || question.key || question.value || question"
                        >
                          {{ question.label || question.question || question.name || question }}
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div v-if="!(required_fields || []).length" class="text-secondary text-xs">
                  No required fields are defined for this service yet.
                </div>
              </div>

              <div class="rounded-4 border bg-white p-3">
                <div class="fw-bold text-xs mb-2">
                  Notes
                </div>
                <div class="text-secondary text-xxs">
                  Ensure that each required field is mapped to a compatible question (e.g. ID number, company registration, date of birth).
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>
  </div>
</div>
